export enum CNSSetLayoutStyles {
  NONE = "NONE",
  NORMAL = "NORMAL",
  CHARACTER = "CHARACTER",
  CINNAMOROLL1 = "CINNAMOROLL1",
  LEFT = "LEFT",
  RIGHT = "RIGHT",
  FULL = "FULL",
  NCT = "NCT"
}